import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Qué es un extracto de hongos?',
    a: 'Es una presentación concentrada de hongos funcionales, pensada para incorporar de forma simple a una rutina de bienestar.'
  }, {
    q: '¿Cuál debería elegir?',
    a: 'Depende de tu objetivo. Reishi se asocia a equilibrio, Cordyceps a energía y Melena de León a enfoque y claridad mental.'
  }, {
    q: '¿Puedo consultar antes de comprar?',
    a: 'Sí. Puedes escribir por WhatsApp para resolver dudas sobre producto, disponibilidad, precio y despacho.'
  }, {
    q: '¿Esto reemplaza un tratamiento médico?',
    a: 'No. Este producto no reemplaza diagnóstico, tratamiento ni indicación médica. Si tienes una condición de salud o tomas medicamentos, consulta con un profesional.'
  }, {
    q: '¿Hay opción de Stock?',
    a: 'Puedes consultar por WhatsApp si hay opciones de compra stock disponible.'
  }, {
    q: '¿Dónde puedo ver más información?',
    a: 'Puedes contactarnos directamente por WhatsApp o visitar nuestras redes sociales.'
  }];
  return <section className="py-24 bg-brand-beige" id="faq" data-id="element-32">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-heading font-bold text-brand-green" data-id="element-35">
            Preguntas frecuentes
          </motion.h2>
        </div>

        <div className="space-y-4" data-id="element-36">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-brand-cream overflow-hidden shadow-sm" data-id="element-37">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-38">
                <span className="font-heading font-bold text-brand-green text-lg pr-8" data-id="element-39">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-40" />
              </button>

              <AnimatePresence data-id="element-41">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-42">
                    <div className="px-6 pb-5 text-brand-brown/80 leading-relaxed border-t border-brand-beige/50 pt-4" data-id="element-43">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}